import React from 'react';
import PropTypes from 'prop-types';

import { defineMessages, T } from '@sm/intl';
import { Align, Button, Modal, ModalBody, ModalFooter } from '@sm/wds-react';

import EMAIL_PREFERENCE_CATEGORY from '../../enums';

const COPY = defineMessages({
  UNSUBSCRIBE_CONFIRMATION_MODAL_NEWSLETTER: {
    id: 'User.UnsubscribeConfirmationModal.Newsletter',
    defaultMessage: "Confirm that you'd like to unsubscribe from Monthly Newsletters.",
    description:
      '[Type: Button][Vis.: med] - Marketing email preferences unsubscribe confirmation modal copy for newsletter category',
  },
  UNSUBSCRIBE_CONFIRMATION_MODAL_SURVEY_BEST_PRACTICES: {
    id: 'User.UnsubscribeConfirmationModal.SurveyBestPractices',
    defaultMessage: "Confirm that you'd like to unsubscribe from Best Practices.",
    description:
      '[Type: Button][Vis.: med] - Marketing email preferences unsubscribe confirmation modal copy for best practices category',
  },
  UNSUBSCRIBE_CONFIRMATION_MODAL_DATA_STORIES: {
    id: 'User.UnsubscribeConfirmationModal.DataStories',
    defaultMessage: "Confirm that you'd like to unsubscribe from Data Stories.",
    description:
      '[Type: Button][Vis.: med] - Marketing email preferences unsubscribe confirmation modal copy for data stories category',
  },
  UNSUBSCRIBE_CONFIRMATION_MODAL_CUSTOMER_OPPORTUNITIES: {
    id: 'User.UnsubscribeConfirmationModal.CustomerOpportunities',
    defaultMessage: "Confirm that you'd like to unsubscribe from Product Updates.",
    description:
      '[Type: Button][Vis.: med] - Marketing email preferences unsubscribe confirmation modal copy for customer opportunities category',
  },
  UNSUBSCRIBE_CONFIRMATION_MODAL_PURCHASE_INQUIRIES: {
    id: 'User.UnsubscribeConfirmationModal.PurchaseInquiries',
    defaultMessage: "Confirm that you'd like to unsubscribe from Solutions and Integrations.",
    description:
      '[Type: Button][Vis.: med] - Marketing email preferences unsubscribe confirmation modal copy for purchase inquiries category',
  },
  UNSUBSCRIBE_CONFIRMATION_MODAL_PRODUCT_RESEARCH: {
    id: 'User.UnsubscribeConfirmationModal.ProductResearch',
    defaultMessage: "Confirm that you'd like to unsubscribe from Product Research.",
    description:
      '[Type: Button][Vis.: med] - Marketing email preferences unsubscribe confirmation modal copy for product research category',
  },
  UNSUBSCRIBE_CONFIRMATION_MODAL_CANCEL: {
    id: 'User.UnsubscribeConfirmationModal.CancelButton',
    defaultMessage: 'CANCEL',
    description: '[Type: Button][Vis.: med] - Marketing email preferences unsubscribe confirmation modal cancel button',
  },
  UNSUBSCRIBE_CONFIRMATION_MODAL_UNSUBSCRIBE: {
    id: 'User.UnsubscribeConfirmationModal.UnsubscribeButton',
    defaultMessage: 'UNSUBSCRIBE',
    description:
      '[Type: Button][Vis.: med] - Marketing email preferences unsubscribe confirmation modal unsubscribe button',
  },
});

const UnsubscribeConfirmationModal = ({ category, show, submitButton, handleCancel }) => (
  <Modal data-testid="UnsubscribeConfirmationModal" show={show} onClose={handleCancel}>
    <ModalBody>
      <div className="wds-p-t-4 wds-p-b-6">
        <T desc={COPY[`UNSUBSCRIBE_CONFIRMATION_MODAL_${EMAIL_PREFERENCE_CATEGORY[category]}`]} />
      </div>
    </ModalBody>
    <ModalFooter>
      <Align placement="right">
        <Button
          data-testid="UnsubscribeConfirmationModal__Cancel"
          variant="ghost"
          color="secondary"
          onClick={handleCancel}
        >
          <T desc={COPY.UNSUBSCRIBE_CONFIRMATION_MODAL_CANCEL} />
        </Button>
        {submitButton}
      </Align>
    </ModalFooter>
  </Modal>
);

UnsubscribeConfirmationModal.propTypes = {
  category: PropTypes.string,
  show: PropTypes.bool.isRequired,
  submitButton: PropTypes.node.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

UnsubscribeConfirmationModal.defaultProps = {
  category: null,
};

export default UnsubscribeConfirmationModal;
